const es = {
  nav: {
    home: "Inicio",
    browse: "Explorar Bodas",
    browseWeddings: "Explorar Bodas",
    dashboard: "Panel",
    messages: "Mensajes",
    profile: "Perfil",
    login: "Iniciar sesi\u00f3n",
    register: "Registrarse",
    logout: "Cerrar sesi\u00f3n",
    admin: "Admin",
  },
  landing: {
    hero: {
      badge: "La plataforma #1 de experiencias de boda",
      title: "Vive bodas inolvidables en todo el mundo",
      subtitle: "WEDVAYA conecta parejas con viajeros que buscan experiencias culturales aut\u00e9nticas. S\u00e9 parte de un momento especial \u2013 como anfitri\u00f3n o invitado.",
      cta_host: "Empezar como anfitri\u00f3n",
      cta_guest: "Descubrir bodas",
    },
    trust: {
      freeRegistration: "Registro gratuito",
      securePayment: "Pago seguro",
      gdprCompliant: "Conforme con RGPD",
    },
    stats: {
      weddings: "Bodas",
      worldwide: "en todo el mundo",
      guests: "Invitados",
      matched: "conectados",
      countries: "Pa\u00edses",
      represented: "representados",
      rating: "Valoraci\u00f3n",
      average: "promedio",
    },
    features: {
      title: "\u00bfPor qu\u00e9 WEDVAYA?",
      subtitle: "Hacemos que compartir experiencias de boda inolvidables sea f\u00e1cil y seguro.",
      secure: {
        title: "Pagos seguros",
        desc: "Todas las transacciones est\u00e1n protegidas por Stripe. Tu dinero est\u00e1 seguro hasta el evento.",
      },
      verified: {
        title: "Perfiles verificados",
        desc: "Verificaci\u00f3n de identidad opcional para mayor confianza entre anfitriones e invitados.",
      },
      global: {
        title: "Eventos globales",
        desc: "Desde bodas rom\u00e1nticas en la Toscana hasta celebraciones tradicionales en India.",
      },
      contact: {
        title: "Contacto directo",
        desc: "Despu\u00e9s de la reserva, puedes comunicarte directamente con tu anfitri\u00f3n.",
      },
      gdpr: {
        title: "Conforme con RGPD",
        desc: "Tus datos est\u00e1n seguros. Cumplimos estrictamente las directrices europeas de protecci\u00f3n de datos.",
      },
      instant: {
        title: "Reserva instant\u00e1nea",
        desc: "Proceso de solicitud r\u00e1pido. Recibir\u00e1s respuesta en 48 horas.",
      },
    },
    howItWorks: {
      title: "C\u00f3mo funciona",
      subtitle: "Solo unos pasos para tu experiencia inolvidable",
      step1: {
        title: "Encontrar una boda",
        desc: "Explora nuestra selecci\u00f3n de bodas \u00fanicas en todo el mundo.",
      },
      step2: {
        title: "Enviar solicitud",
        desc: "Pres\u00e9ntate a la pareja y cu\u00e9ntales por qu\u00e9 quieres asistir.",
      },
      step3: {
        title: "Confirmaci\u00f3n y pago",
        desc: "Tras la aprobaci\u00f3n, paga de forma segura en l\u00ednea. Solo entonces se reserva tu plaza.",
      },
      step4: {
        title: "Celebrar",
        desc: "Vive una boda aut\u00e9ntica y crea recuerdos para toda la vida.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "Publicar tu boda",
        desc: "Crea un perfil para tu boda con todos los detalles importantes.",
      },
      step2: {
        title: "Revisar solicitudes",
        desc: "Consulta los perfiles de los invitados interesados.",
      },
      step3: {
        title: "Recibir pago",
        desc: "Despu\u00e9s del evento, recibes autom\u00e1ticamente el 85% de los ingresos.",
      },
      step4: {
        title: "Celebrar juntos",
        desc: "Comparte tu d\u00eda especial con personas de todo el mundo.",
      },
    },
    tabs: {
      forGuests: "Para invitados",
      forHosts: "Para anfitriones",
    },
    testimonials: {
      title: "Lo que dice nuestra comunidad",
      subtitle: "Experiencias reales de personas reales",
    },
    featured: {
      title: "Bodas destacadas",
      subtitle: "Descubre celebraciones \u00fanicas en todo el mundo",
      viewAll: "Ver todas",
      perPerson: "por persona",
    },
    cta: {
      title: "\u00bfListo para tu experiencia inolvidable?",
      subtitle: "\u00danete a la comunidad WEDVAYA",
      description: "Ya sea que quieras compartir tu boda con el mundo o busques una experiencia de viaje \u00fanica \u2013 WEDVAYA lo hace posible.",
      button: "Registrarse gratis",
      becomeHost: "Convertirse en anfitri\u00f3n",
      learnMore: "Saber m\u00e1s",
    },
    press: {
      title: "Visto en",
    },
  },
  auth: {
    login: {
      title: "Bienvenido de nuevo",
      email: "Correo electr\u00f3nico",
      password: "Contrase\u00f1a",
      button: "Iniciar sesi\u00f3n",
      noAccount: "\u00bfNo tienes cuenta?",
      register: "Reg\u00edstrate ahora",
      forgotPassword: "\u00bfOlvidaste tu contrase\u00f1a?",
    },
    register: {
      title: "Crear cuenta",
      name: "Nombre completo",
      email: "Correo electr\u00f3nico",
      password: "Contrase\u00f1a",
      role: "Quiero...",
      roleHost: "Organizar una boda",
      roleGuest: "Asistir a bodas",
      terms: "Acepto los t\u00e9rminos y la pol\u00edtica de privacidad",
      button: "Registrarse",
      hasAccount: "\u00bfYa tienes cuenta?",
      login: "Inicia sesi\u00f3n",
    },
    forgotPassword: {
      title: "\u00bfOlvidaste tu contrase\u00f1a?",
      description: "Ingresa tu correo y te enviaremos un enlace para restablecer",
      submit: "Enviar enlace",
      sent: "Revisa tu correo",
      sentDescription: "Si existe una cuenta con ese correo, recibir\u00e1s un enlace para restablecer tu contrase\u00f1a.",
      backToLogin: "Volver al inicio de sesi\u00f3n",
    },
    resetPassword: {
      title: "Restablecer contrase\u00f1a",
      description: "Ingresa tu nueva contrase\u00f1a",
      newPassword: "Nueva contrase\u00f1a",
      confirmPassword: "Confirmar contrase\u00f1a",
      submit: "Restablecer contrase\u00f1a",
      success: "\u00a1Contrase\u00f1a restablecida!",
      successDesc: "Tu contrase\u00f1a se ha restablecido correctamente. Ya puedes iniciar sesi\u00f3n.",
      goToLogin: "Ir al inicio de sesi\u00f3n",
      mismatch: "Las contrase\u00f1as no coinciden",
      tooShort: "La contrase\u00f1a debe tener al menos 6 caracteres",
    },
    verification: {
      verifying: "Verificando tu correo...",
      pleaseWait: "Por favor espera",
      successTitle: "\u00a1Correo verificado!",
      success: "\u00a1Tu correo ha sido verificado exitosamente!",
      errorTitle: "Verificaci\u00f3n fallida",
      noToken: "No se proporcion\u00f3 token de verificaci\u00f3n",
      goToLogin: "Ir al inicio de sesi\u00f3n",
      tryAgain: "Registrarse de nuevo",
    },
  },
  dashboard: {
    host: {
      title: "Panel del anfitri\u00f3n",
      myWeddings: "Mis bodas",
      applications: "Solicitudes",
      earnings: "Ganancias",
      messages: "Mensajes",
      createWedding: "Crear boda",
      noWeddings: "No hay bodas creadas",
    },
    guest: {
      title: "Panel del invitado",
      myApplications: "Mis solicitudes",
      browseWeddings: "Explorar bodas",
      messages: "Mensajes",
      profile: "Mi perfil",
    },
  },
  wedding: {
    search: {
      title: "Encontrar bodas",
      location: "Ubicaci\u00f3n",
      date: "Fecha",
      price: "Precio",
      search: "Buscar",
      reset: "Restablecer",
      noResults: "No se encontraron bodas",
    },
    card: {
      slots: "plazas disponibles",
      perGuest: "por invitado",
      apply: "Aplicar",
      viewDetails: "Ver detalles",
    },
    detail: {
      about: "Sobre esta boda",
      host: "Anfitri\u00f3n",
      location: "Ubicaci\u00f3n",
      date: "Fecha",
      dresscode: "C\u00f3digo de vestimenta",
      price: "Precio por invitado",
      slots: "Plazas disponibles",
      apply: "Aplicar ahora",
      alreadyApplied: "Ya aplicaste",
    },
    create: {
      title: "Crear nueva boda",
      titleField: "T\u00edtulo",
      description: "Descripci\u00f3n",
      location: "Ubicaci\u00f3n",
      country: "Pa\u00eds",
      date: "Fecha",
      dresscode: "C\u00f3digo de vestimenta",
      price: "Precio por invitado",
      slots: "N\u00famero de invitados",
      currency: "Moneda",
      submit: "Crear boda",
    },
  },
  application: {
    status: {
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado",
    },
    payment: {
      pending: "Pago pendiente",
      paid: "Pagado",
      pay: "Pagar ahora",
    },
    approve: "Aprobar",
    reject: "Rechazar",
  },
  review: {
    title: "Escribir una reseña",
    description: "Comparte tu experiencia con",
    ratingLabel: "¿Cómo calificarías tu experiencia?",
    rating1: "Muy mala",
    rating2: "Regular",
    rating3: "Buena",
    rating4: "Muy buena",
    rating5: "Excelente",
    commentLabel: "Tu reseña",
    optional: "opcional",
    commentPlaceholder: "¡Cuéntales a los demás sobre tu experiencia...",
    for: "Reseña para",
    submit: "Enviar reseña",
    success: "¡Reseña enviada con éxito!",
    error: "Error al enviar la reseña",
    selectRating: "Selecciona una calificación",
    noReviews: "Aún no hay reseñas",
    received: "Reseñas recibidas",
    averageRating: "Calificación promedio",
    writeReview: "Escribir reseña",
    reviewed: "Reseñado",
    completedWedding: "Esta boda está completada. Puedes escribir una reseña ahora.",
  },
  messages: {
    title: "Mensajes",
    noMessages: "Sin mensajes",
    placeholder: "Escribe un mensaje...",
    send: "Enviar",
  },
  admin: {
    title: "Panel de Admin",
    stats: {
      users: "Usuarios",
      hosts: "Anfitriones",
      guests: "Invitados",
      weddings: "Bodas",
      activeWeddings: "Bodas activas",
      applications: "Solicitudes",
      revenue: "Ingresos totales",
      platformEarnings: "Ganancias de la plataforma",
    },
    tabs: {
      overview: "Resumen",
      users: "Usuarios",
      weddings: "Bodas",
      transactions: "Transacciones",
    },
    actions: {
      ban: "Banear",
      unban: "Desbanear",
      feature: "Destacar",
      unfeature: "Quitar destacado",
    },
  },
  common: {
    loading: "Cargando...",
    error: "Ocurri\u00f3 un error",
    success: "\u00c9xito",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    back: "Atr\u00e1s",
    next: "Siguiente",
    language: "Idioma",
    currency: "Moneda",
  },
  footer: {
    about: "Acerca de",
    privacy: "Privacidad",
    terms: "T\u00e9rminos",
    contact: "Contacto",
    description: "La plataforma global para experiencias de boda inolvidables.",
    copyright: "\u00a9 2024 WEDVAYA. Todos los derechos reservados.",
  },
  notifications: {
    title: "Notificaciones",
    empty: "A\u00fan no hay notificaciones",
    markAllRead: "Marcar todo como le\u00eddo",
  },
  chat: {
    conversations: "Conversaciones",
    search: "Buscar conversaciones...",
    noConversations: "A\u00fan no hay conversaciones",
    selectConversation: "Selecciona una conversaci\u00f3n",
    selectConversationDesc: "Elige una conversaci\u00f3n de la lista para empezar a chatear",
    online: "En l\u00ednea",
    offline: "Desconectado",
    connecting: "Conectando...",
    noMessages: "A\u00fan no hay mensajes",
    startConversation: "\u00a1Inicia la conversaci\u00f3n!",
    placeholder: "Escribe un mensaje...",
    you: "T\u00fa",
  },
  cookies: {
    title: "Usamos cookies",
    description: "Usamos cookies para mejorar tu experiencia, analizar el tr\u00e1fico y con fines de marketing.",
    acceptAll: "Aceptar todo",
    rejectAll: "Rechazar todo",
    customize: "Personalizar",
    settingsTitle: "Configuraci\u00f3n de cookies",
    functional: "Cookies funcionales",
    functionalDesc: "Esenciales para el funcionamiento del sitio.",
    analytics: "Cookies de an\u00e1lisis",
    analyticsDesc: "Nos ayudan a entender c\u00f3mo interact\u00faan los visitantes con el sitio.",
    marketing: "Cookies de marketing",
    marketingDesc: "Usadas para mostrar anuncios personalizados.",
    saveSettings: "Guardar configuraci\u00f3n",
  },
};

export default es;
